import SockJS from 'sockjs-client';
import { Client, over } from 'stompjs';

export const initSocket = (onClose?: () => void): Client => {
    const socket = new SockJS('https://api.ontiloo.com/api/v1/gs-guide-websocket');
    if (onClose) socket.addEventListener('close', onClose);
    return over(socket);
};

/** stompjs 2.x giu transport o `client.ws` nhung typing khong khai bao, mo rong tai day. */
export type ClientWithTransport = Client & {
  ws?: { readyState?: number; close?: () => void };
};

/**
 * Dong han mot client.
 *
 * `disconnect` phai gui frame DISCONNECT nen se nem loi khi transport da hong, va
 * nem TRUOC khi kip dong transport. Vi vay dong thang transport o buoc hai: bo sot
 * buoc nay thi mot socket treo van song va tiep tuc nhan message song song voi
 * socket moi, lam moi message duoc xu ly hai lan.
 */
export const disposeSocket = (client: Client) => {
  try {
    client.disconnect(() => undefined);
  } catch {
    // Khong gui duoc frame DISCONNECT, xuong thang buoc dong transport.
  }
  try {
    (client as ClientWithTransport).ws?.close?.();
  } catch {
    // Transport da dong truoc do.
  }
};

export const APPOINTMENT_TOPIC = '/topic/book-appointment-completed';
export const SYNC_TURN = '/topic/turn';
export const INBOUND_CALL_BOOKING_TOPIC = '/topic/inbound-call-booking';
/** Mang nguyen appointment detail khi ticket cua lich doi trang thai thanh toan. */
export const APPOINTMENT_UPDATED_TOPIC = '/topic/appointment-updated';

/**
 * Chu ky tu kiem tra cac topic con connect khong.
 *
 * Phep kiem tra chi doc co trang thai, khong goi mang, nen con so nay chu yeu la
 * do tre te nhat truoc khi mot socket chet bi phat hien.
 */
export const SOCKET_HEALTH_CHECK_INTERVAL_MS = 5 * 60 * 1000;

/** Do tre giua cac lan thu lai khi chinh buoc connect bao loi. */
export const SOCKET_RECONNECT_DELAY_MS = 120000;

/**
 * Qua moc nay ma handshake chua xong thi coi nhu treo.
 *
 * Health check phai bo qua ket noi dang bat tay de khong pha ngang no; khong co
 * han nay thi mot handshake treo vinh vien se tat han health check.
 */
export const SOCKET_CONNECT_TIMEOUT_MS = 30000;
